import { memo } from 'react';

import Arrow from 'assets/icon/arrow-active.svg?react';

import { Button } from '../../molecules/button';
import sm from './styles.module.scss';
import { MultipleButtonsProp } from './types';

const MultipleButtonExtension = ({
  handlePreviousDocumentClick,
  handleNextDocumentClick,
  previousDocumentButtonEnabled,
  nextDocumentButtonEnabled,
}: MultipleButtonsProp) => (
  <span className={sm.MultipleBtn}>
    <>
      <Button
        view="Only_Icon"
        type="button"
        tooltipText="Previous Document"
        withPrimaryStylesOnHover
        preIcon={<Arrow className={sm.UpArrow} />}
        isOutlined
        isDisabled={!previousDocumentButtonEnabled}
        onClick={handlePreviousDocumentClick}
      />
      <Button
        view="Only_Icon"
        type="button"
        tooltipText={'Next Document'}
        withPrimaryStylesOnHover
        preIcon={<Arrow className={sm.DownArrow} />}
        isOutlined
        onClick={handleNextDocumentClick}
        isDisabled={!nextDocumentButtonEnabled}
      />
    </>
  </span>
);

export default memo(MultipleButtonExtension);
